import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import enTranslations from "./locales/en-US.json";
import enCuteTranslations from "./locales/en-US-cute.json";
import cnTranslations from "./locales/zh-CN.json";
import jpTranslations from "./locales/ja-JP.json";
import esTranslations from "./locales/es-ES.json";
import frTranslations from "./locales/fr-FR.json";
import { findMissingKeys } from "./utils/helperFunctions";

const resources = {
  "en-US": {
    translation: enTranslations,
  },
  "en-US-cute": {
    translation: enCuteTranslations,
  },
  "zh-CN": {
    translation: cnTranslations,
  },
  // "ja-JP": {
  //   translation: jpTranslations,
  // },
  // "es-ES": {
  //   translation: esTranslations,
  // },
  // "fr-FR": {
  //   translation: frTranslations,
  // },
};

// const keys = Object.keys(resources);
// for (var index = 1; index < keys.length; index += 1) {
//   const key = keys[0];
//   const key2 = keys[index];
//   const missingInCN = findMissingKeys(resources[key].translation, resources[key2].translation);
//   console.log(`****🚫 Missing keys in ${key2} (structured):`, missingInCN);
// }
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      // Chinese variants fallback
      zh: ["zh-CN"],
      "zh-TW": ["zh-CN"],
      "zh-HK": ["zh-CN"],
      "zh-MO": ["zh-CN"],

      // English variants fallback
      en: ["en-US"],
      "en-GB": ["en-US"],
      "en-CA": ["en-US"],
      "en-AU": ["en-US"],
      "en-NZ": ["en-US"],
      "zh-CN": ["en-US"],

      // Default fallback
      default: ["en-US"],
    },
    load: "all", // default; keeps full locale matching like 'zh-CN', 'en-US'
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: resources,
  });

export default i18n;
